<template>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body">

          <div v-if="Object.keys(video).length" class="embed-responsive embed-responsive-16by9">
            <vimeo-player ref="player" :video-url="'https://vimeo.com/' + video.vimeo_id" :player-width="960" :player-height="480"></vimeo-player>
          </div>

          <h3 class="text-dark">{{video.title}}</h3>

          <div class="row mb-3">
            <p class="col-8"><b>リリース</b>: {{video.release_time}}</p>
            <p class="col-4"><button class="btn btn-light btn-block" @click="deleteAllViewOfVideo">視聴履歴を一括削除</button></p>
          </div>

          <div class="row">
            <div class="col-6 text-center">
              <h4>{{video.total_viewed}}</h4>
              <p class="text-dark">総視聴回数</p>
            </div>
            <div class="col-6 text-center">
              <h4>{{video.time_average_as_minute}}</h4>
              <p class="text-dark">平均総再生時間</p>
            </div>
          </div>
          <div class="card mt-3" v-if="video.get_description">
            <div class="card-body">
              <span>{{video.get_description}}</span>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="row" v-if="Object.keys(chartData).length > 0">
            <div class="col-12 mb-2">
              <div class="d-flex justify-content-between">
                <button class="btn btn-primary" @click="getPreviousMonth()">
                  <i class="fas fa-angle-double-left"></i>
                  {{previousDate.getFullYear() }}年 {{previousDate.getMonth() + 1}}月
                </button>
                <div v-if="nextDate < currentDate">
                  <button class="btn btn-primary" @click="getNextMonth()">
                    {{nextDate.getFullYear() }}年 {{nextDate.getMonth() + 1}}月
                    <i class="fas fa-angle-double-right"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="col-12 mb-5">
              <div class="card">
                <div class="card-body">
                  <div class="page-title-box">
                    <div class="page-title-btn float-right">
                      <button @click="downloadCsv('viewed_day')" class="btn btn-primary btn-rounded">CSVダウンロード</button>
                    </div>

                    <h4 class="page-title header-title">{{year}}年 {{month + 1}}月 視聴回数/日</h4>
                  </div>
                  <div class="table-responsive">
                    <table class="table">
                      <thead>
                        <tr>
                          <th v-for="c in chartData.month">
                            <div class="text-nowrap text-right">
                              <a class="btn btn-light btn-block" :href="'/' + report_pathname + '/videos/' + videoId + '/report/years/' + year + '/monthes/' + (month + 1) + '/days/' + c.day">{{c.label}}</a>
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td v-for="c in chartData.month">
                            <div class="text-nowrap text-right">
                              <a class="btn btn-light btn-block" :href="'/' + report_pathname + '/videos/' + videoId + '/viewed_videos?date_from=' + year + '-' + (month + 1) + '-' + c.day + '&date_to=' + year + '-' + (month + 1) + '-' + c.day">{{c.total}}</a>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <bar-chart :chartdata="chartData.month" chart_id="viewed_of_day" bar_label="視聴回数" :bar_color="bar_color"></bar-chart>
                </div>
              </div>
            </div>
            <div class="col-12 mb-5">
              <div class="card">
                <div class="card-body">
                  <div class="page-title-box">
                    <div class="page-title-btn float-right">
                      <button @click="downloadCsv('viewed_month')" class="btn btn-primary btn-rounded">CSVダウンロード</button>
                    </div>

                    <h4 class="page-title header-title">{{year}}年 視聴回数/月</h4>
                  </div>
                  <div class="table-responsive">
                    <table class="table">
                      <thead>
                        <tr>
                          <th v-for="c in chartData.year">
                            <div class="text-nowrap text-right">
                              <a class="btn btn-light btn-block" :href="'/' + report_pathname + '/videos/' + videoId + '/report/years/' + year + '/monthes/' + c.month">{{c.label}}</a>
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td v-for="c in chartData.year">
                            <div class="text-nowrap text-right">
                              <a class="btn btn-light btn-block" :href="'/' + report_pathname + '/videos/' + videoId + '/viewed_videos?date_from=' + year + '-' + c.month + '-01&date_to=' + year + '-' + c.month + '-' + c.end_of_month">{{c.total}}</a>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <bar-chart :chartdata="chartData.year" chart_id="viewed_of_month" bar_label="視聴回数" :bar_color="bar_color"></bar-chart>
                </div>
              </div>
            </div>
            <div class="col-12 mb-5">
              <div class="card">
                <div class="card-body">
                  <div class="page-title-box">
                    <div class="page-title-btn float-right">
                      <button @click="downloadCsv('viewed_time')" class="btn btn-primary btn-rounded">CSVダウンロード</button>
                      <h6>視聴時間合計：{{video.viewing_time_as_minute}}（分）</h6>
                    </div>

                    <h4 class="page-title header-title">視聴時間</h4>
                  </div>
                  <div class="table-responsive">
                    <table class="table">
                      <thead>
                        <tr>
                          <th v-for="c in chartData.watched">
                            <div class="text-nowrap text-right">
                              {{c.label}}
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td v-for="c in chartData.watched">
                            <div class="text-nowrap text-right">
                              {{c.total}}
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <bar-chart :chartdata="chartData.watched" chart_id="average_viewing" bar_label="視聴時間" bar_color="#9A8FC3"></bar-chart>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Player from '@vimeo/player';
import BarChart from "./BarChart";

export default {
  props: {
    api_pathname: {
      type: String,
      default: ""
    },
    report_pathname: {
      type: String,
      default: ""
    },
    bar_color: {
      type: String,
      default: "#2196f3"
    },
  },
  components: {BarChart},
  data() {
    return {
      videoId: null,
      organizationEncodedId: null,
      video: {},
      currentDate: new Date(),
      date: new Date(),
      month: new Date().getMonth(),
      year: new Date().getFullYear(),
      previousDate: null,
      nextDate: null,
      chartData: {},
    }
  },
  methods: {
    initVimeo() {
      const arrPath              = window.location.pathname.split("/")
      this.videoId               = arrPath.slice(-1)[0]
      this.organizationEncodedId = arrPath.slice(-3)[0]
      this.getVideo()
    },
    async initDate(){
      const month = this.getParam("month")
      const year  = this.getParam("year")

      if( month && year){
        this.date = new Date(year, month - 1, 1)
        if (this.date > this.currentDate){
          this.date = this.currentDate
        }
      }
      this.year  = this.date.getFullYear()
      this.month = this.date.getMonth()

      this.previousDate = new Date(this.year, this.month - 1, 1)
      this.nextDate     = new Date(this.year, this.month + 1, 1)
    },
    async getVideo() {
      await this.axios.get('/api/v1/' + this.api_pathname + '/videos/' + this.videoId + '?date=' + this.date).then((response) => {
        this.video     = response.data.video
        this.chartData = response.data.chartdata
      }).catch((error) => {
      })
    },
    getPreviousMonth() {
      const href = location.pathname = "?month=" + (this.previousDate.getMonth() + 1) + "&year=" + this.previousDate.getFullYear()
      location.href = href
    },
    getNextMonth() {
      const href = location.pathname = "?month=" + (this.nextDate.getMonth() + 1) + "&year=" + this.nextDate.getFullYear()
      location.href = href
    },
    getParam(name, url) {
      if (!url) url = window.location.href
      name = name.replace(/[\[\]]/g, "\\$&")
      let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
          results = regex.exec(url)
      if (!results) return null
      if (!results[2]) return ''
      return decodeURIComponent(results[2].replace(/\+/g, " "))
    },
    downloadCsv(type) {
      let href = "/api/v1/" + this.api_pathname + "/videos/" + this.videoId + ".csv?date=" + this.date + "&type=" + type;
      open(href);
    },
    async deleteAllViewOfVideo() {

      if(!window.confirm('本当に削除してもよろしいでしょうか？削除には時間がかかる場合があります。クリック後リロードしてください。')){
        return
      }
      let href = "/api/v1/" + this.api_pathname + "/videos/" + this.videoId + "/remove_all_view_video";
      await this.axios.delete(href).then((response) => {
        this.$mount()
      }).catch((error) => {})
    }
  },
  async mounted() {
    await this.initDate()
    this.initVimeo()
  }
}
</script>
